export class Settings {
  public readonly settings_type!: number;
  public readonly settings_value!: unknown;
}

export const settingsTypes = {
  CRM: 'crm',
  EULA: 'eula',
  FILE_OPERATION: 'file_operation',
};
